export const SAVED_SOURCE_MEMBERS = [
  "",
  " sundayageegn",
  " sydneymorningheraldegn",
  "ajn",
  "australianegn",
  "australianfinancialreview",
  "ballaratcourier",
  "bathurstwesternadvocate",
  "bendigoadvertiservic",
  "bordermailvic",
  "brochure",
  "burnieadvocate",
  "canberratimespanorama",
  "capelodgewa",
  "careersatle",
  "courier mail qld egn",
  "Courier Mail Saturday - EGN",
  "daily telgraph egn",
  "fin magazine",
  "goldcoastbulletinegn",
  "GoldCoastBulletinEGN",
  "goodweekendvic",
  "herald sun egn",
  "heraldsun",
  "illawarramercury",
  "instorestrutcards",
  "launcestonexaminer",
  "luxpluspressstrip",
  "LuxPlusPressStrip",
  "luxury escapes best of '22",
  "luxury escapes best of '22 competition",
  "luxuryescapes",
  "maldivesexclusiveoffers",
  "mdacommunitydiary",
  "new zealand herald",
  "New Zealand Herald",
  "newcastleheraldegn",
  "northerndailyleader",
  "orangecentralwesterndaily",
  "otago daily times",
  "otagodailytimes",
  "over sixties",
  "press",
  "Press",
  "pressstrip",
  "qr_test",
  "RCL Press Ad",
  "satdailytelegraphegn",
  "satheraldsun",
  "satherlandsun",
  "saturday advertiser",
  "Saturday Advertiser",
  "Saturday Daily Telegraph - EGN",
  "saturday daily telegraph egn",
  "saturday herald sun",
  "Saturday Herald Sun",
  "saturday telegraph uk",
  "saturdaydailyegn",
  "SaturdayHeraldSun%20",
  "SaturdayHeraldSun+",
  "saturdayheraldsunegn",
  "saturdayheraldsunwrap",
  "saturdayweekendmag",
  "strutcards",
  "Sun Herald - EGN",
  "sun herald egn",
  "Sun Herald Sydney - Wrap",
  "sun herald traveller",
  "Sunday Age - EGN",
  "sunday age egn",
  "sunday age traveller",
  "Sunday Herald Sun - EGN",
  "Sunday Herald Sun - Escape",
  "sunday herald sun egn",
  "sunday herald sun escape",
  "Sunday Mail QLD - EGN",
  "Sunday Mail QLD - Escape",
  "sunday mail qld egn",
  "sunday mail qld escape",
  "sunday mail s.a egn",
  "sunday mail s.a escape",
  "Sunday Mail SA - EGN",
  "Sunday Mail SA - Escape",
  "sunday star times nz",
  "Sunday Telegraph - EGN",
  "Sunday Telegraph - Escape",
  "sunday telegraph egn",
  "sunday telegraph escape",
  "Sunday Times UK",
  "sunday times w.a egn",
  "sunday times w.a travel",
  "Sunday Times WA - EGN",
  "Sunday Times WA - Travel",
  "sundayagetraveller",
  "SundayAgeTraveller",
  "sundayagewrap",
  "sundaycanberratimes",
  "sundaydailytelegraphegn",
  "sundayheraldegn",
  "sundayheraldsun",
  "SundayHeraldSunEGN%20%C2%A0",
  "SundayHeraldSunEGN%C2%A0",
  "SundayHeraldSunEGN+%C2%A0",
  "sundayheraldsunegnwrap",
  "SundayHeraldSunEGNWRAP",
  "sundayheraldsunescape ",
  "sundaymailqld",
  "sundaymailqldegnwrap",
  "SundayMailQLDEGNWRAP",
  "sundaymailqldescape ",
  "sundaymailqldescapegeneralfeature",
  "SundayMailQLDEscapeGeneralFeature",
  "sundaymails.aegnwrap",
  "sundaymailsaegn",
  "SundayMailSAEGN",
  "sundaymailsaescape",
  "SundayMailSAEscape",
  "sundaystartimesnz",
  "sundaysunheraldtraveller",
  "sundaytasmanian",
  "sundaytelegraphegnwrap",
  "SundayTelegraphEGNWRAP",
  "sundaytimeswa",
  "sundaytimeswaegn",
  "SundayTimesWAEGN",
  "sundaytimeswatravel",
  "SundayTimesWATravel",
  "sunherald",
  "sunherald egn",
  "sunheraldsunegn",
  "sunheraldsunescape",
  "sunheraldsunescapevic",
  "sunheraldtraveller",
  "sunmailescapeqld",
  "Sydney Morning Herald - EGN",
  "Sydney Morning Herald - Traveller",
  "sydney morning herald boxing day",
  "sydney morning herald egn",
  "sydney morning herald traveller",
  "sydneymorningherald",
  "SydneyMorningHerald",
  "sydneymorningheraldwrap",
  "The Age - EGN",
  "The Age - Traveller",
  "the age boxing day",
  "the age egn",
  "the age traveller",
  "The Australian - EGN",
  "the australian egn",
  "the dominion wellington nz",
  "the press christchurch nz",
  "The Sunday Age - Wrap",
  "The%20Australian%20EGN",
  "The+Australian+EGN",
  "theageeng",
  "theagewrap",
  "theaustralian",
  "thedominionwellingtonnz",
  "thenightlyonglossmagazine",
  "thepresschristchurchnz",
  "thesundayagetraveller",
  "thesundaytasmanian",
  "thesunuk",
  "thewaggadailyadvertiser",
  "theweeklytimes",
  "toursusppressstrip",
  "Traveller Editorial",
  "trip planner press strip",
  "Unknown",
  "warrnamboolstandardvic",
  "West Australian - EGN",
  "West Australian - Travel",
  "west australian boxing day",
  "west australian egn",
  "west australian travel",
  "westaustralian",
  "westaustralianair",
] as const;
